
export default {
	head: {
		bodyAttrs: {
			dir: 'rtl',
		},
	},
}
